import React from 'react';

function HighlightedText({ text, searchQuery }) {
  if (!searchQuery) return text;

  const parts = text.split(new RegExp(`(${searchQuery})`, 'gi'));
  
  return (
    <span>
      {parts.map((part, index) => 
        part.toLowerCase() === searchQuery.toLowerCase() ? (
          <span key={index} className="bg-yellow-200">{part}</span>
        ) : (
          part
        )
      )}
    </span>
  );
}

export default HighlightedText; 